if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"][name="add"]') || this.querySelector('[type="submit"]');
        this.submitSpinner = this.submitButton?.querySelector('.loading__spinner');
        this.submitButton?.addEventListener('click', () => {
          if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
          this.submitButton.classList.add('loading');
          this.submitSpinner?.classList.remove('hidden');
        });

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      setSubmitLoadingState(isLoading) {
        if (!this.submitButton) return;

        if (isLoading) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.setAttribute('aria-busy', 'true');
          this.submitButton.classList.add('loading');
          this.submitSpinner?.classList.remove('hidden');
          return;
        }

        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-busy');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.submitSpinner?.classList.add('hidden');
      }

      waitForCartDrawerOpen() {
        if (!this.cart || this.cart.tagName !== 'CART-DRAWER' || this.error) return Promise.resolve();
        if (this.cart.classList.contains('active')) return Promise.resolve();

        return new Promise((resolve) => {
          let resolved = false;
          const resolveOnce = () => {
            if (resolved) return;
            resolved = true;
            clearTimeout(timeoutId);
            this.cart.removeEventListener('cart-drawer:open', resolveOnce);
            resolve();
          };

          this.cart.addEventListener('cart-drawer:open', resolveOnce, { once: true });
          const timeoutId = setTimeout(resolveOnce, 1500);
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submittedButton = evt.submitter?.matches('[type="submit"]') ? evt.submitter : null;
        if (submittedButton) {
          this.submitButton = submittedButton;
          this.submitSpinner = this.submitButton.querySelector('.loading__spinner');
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.setSubmitLoadingState(true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            if (this.cart && this.cart.tagName === 'CART-DRAWER') {
              this.cart.open(this.submitButton);
            }
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.waitForCartDrawerOpen().finally(() => {
              this.setSubmitLoadingState(false);
            });
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
